module.exports = __webpack_public_path__ + "img/2aba9464a8564c42ac4398b67d7e88ca-1440.85590527.jpg";